import React, { Fragment } from 'react';

const QSR = 'quick-search-result';
const QSR_ITEM = `${QSR}__item`;

const sameCategory = (item, index, array) =>
  (index > 0 && array[index - 1].category === array[index].category) || item.showAll;

const hasLinkDisabledClass = (url) => {
  if (!url) return `${QSR}__link--disabled`;
};

const itemLinkClassName = (showAll, url) =>
  `${QSR}${showAll ? '__show-all' : '__link ' + hasLinkDisabledClass(url)}`;

const selectedItemClassName = (selectedItem, index) => {
  return (selectedItem === index) ? `${QSR_ITEM}--selected` : ``;
};

const QuickSearchResult = ({ result, selectedItem, searchUrl }) => {
  return (
    <ul className={QSR}>
      {result &&
        result.map((item, index, array) => {
          const { category, showAll, url, hasImage, imageSource, name } = item;
          const imageVisible = hasImage && imageSource;
  
          return (
            <Fragment key={index}>
              {category === '' || !sameCategory(item, index, array) ? (
                <li className={`${QSR_ITEM} ${QSR}__group-header`}>{category}</li>
              ) : null}
              <li
                className={`${QSR_ITEM} ${selectedItemClassName(selectedItem, index)}`}
              >
                <a
                  className={itemLinkClassName(showAll, url)}
                  href={showAll ? searchUrl : url}
                >
                  {imageVisible && (
                    <img className={`${QSR}__image`} src={imageSource} />
                  )}
                  <div>{name}</div>
                </a>
              </li>
            </Fragment>
          );
        })}
    </ul>
  )
};

export default QuickSearchResult;
